import React, {
  useMemo,
} from 'react'

import PropTypes from 'prop-types'

import LocationContext from './LocationContext'


export default function LocationProvider({ children, countryCode }) {
  const value = useMemo(() => ({
    countryCode,
  }), [countryCode])

  return (
    <LocationContext.Provider
      value={ value }
    >
      { children }
    </LocationContext.Provider>
  )
}

LocationProvider.propTypes = {
  children: PropTypes.node,
  countryCode: PropTypes.string,
}
